<div class="m-multi-select-dropdown">
  <div id="{{ popverId }}" (click)="openDropdown()">
    <span
      class="m-multi-select-dropdown__box"
      [ngClass]="{ 'm-multi-select-dropdown__box--disabled': this._dropdownConfig.isDisabled }"
    >
      <ng-container *ngIf="this._dropdownConfig.isClearOption">
        <ng-container *ngFor="let item of selectedDropdownList | slice : 0 : 10; let i = index">
          <span class="m-multi-select-dropdown__selected-item-listing" *ngIf="item.isSelected">
            <span class="selected-item">
              <span class="selected-item__value">{{ item.displayName ?? item.value.toString() | translate }}</span>
              <span class="selected-item__cross" (click)="onDeSelectItemFromClearCrossIcon($event, item.value)"
                >x</span
              ></span
            ></span
          >
        </ng-container>
        <span *ngIf="selectedDropdownList.length > 10" class="dd__more-item"
          >{{ selectedDropdownList.length - 10 }} more
        </span>
      </ng-container>
      <ng-container *ngIf="!this._dropdownConfig.isClearOption">
        <ng-container *ngFor="let item of selectedDropdownList | slice : 0 : 10; let i = index">
          <span *ngIf="item.isSelected">
            <pre class="pre-styles">{{ item.displayName ?? item.value.toString() | translate }}</pre>
          </span>
          <span *ngIf="item.isSelected && i !== selectedDropdownList.length - 1"> , </span>
        </ng-container>
        <span *ngIf="selectedDropdownList.length > 10" class="dd__more-item"
          >{{ selectedDropdownList.length - 10 }} more
        </span>
      </ng-container>
      <span *ngIf="selectedDropdownList.length === 0" class="placeHolder">{{ this._dropdownConfig.placeHolder }}</span>
      <span class="m-multi-select-dropdown__dropdown-chevron"><ion-img [src]="dropdownChevron"></ion-img></span
    ></span>
  </div>
  <ion-popover
    [isOpen]="isDropdownOpen"
    [dismissOnSelect]="!isDropdownOpen"
    (didDismiss)="handlePopOverDismiss()"
    trigger="{{ this._dropdownConfig.isDisabled ? '' : popverId }}"
    size="cover"
    side="bottom"
    alignment="start"
    class="m-multi-select-dropdown__popover"
  >
    <ng-template>
      <div>
        <div class="m-multi-select-dropdown__listing-search">
          <ion-searchbar
            mode="ios"
            color="light"
            [placeholder]="'multi_select.Search' | translate"
            (ionChange)="onSearch($event)"
            (ionClear)="onClearSearch()"
          ></ion-searchbar>
        </div>
        <div class="m-multi-select-dropdown__listing">
          <div [ngClass]="{ 'listing-container': true, 'listing-container--virtual-scroll': !!virtualScroll }">
            <cdk-virtual-scroll-viewport
              *ngIf="virtualScroll; else normalList"
              [itemSize]="virtualScroll.itemSize"
              [minBufferPx]="virtualScroll.minBufferPx"
              [maxBufferPx]="virtualScroll.maxBufferPx"
            >
              <ng-container
                *cdkVirtualFor="let option of filteredDropdownList; let i = index; trackBy: trackByOptionValue"
                [ngTemplateOutlet]="checkboxRow"
                [ngTemplateOutletContext]="{ $implicit: option, index: i }"
              >
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </ng-template>
  </ion-popover>
</div>

<ng-template #normalList>
  <ng-container
    *ngFor="let option of filteredDropdownList; let i = index; trackBy: trackByOptionValue"
    [ngTemplateOutlet]="checkboxRow"
    [ngTemplateOutletContext]="{ $implicit: option, index: i }"
  >
  </ng-container>
</ng-template>

<ng-template #checkboxRow let-option let-i="index">
  <button
    type="button"
    [ngClass]="{ 'checkbox-row--rounded': !this._dropdownConfig.isMultiSelect, 'checkbox-row': true }"
    [attr.aria-pressed]="option.isSelected"
    (click)="onSelectOrDeselect($event, option)"
  >
    <ion-checkbox [checked]="option.isSelected" size="4" tabindex="-1"></ion-checkbox>
    <span class="label pre-styles">
      {{ (option.displayName ?? option.value).toString() | translate }}
    </span>
  </button>
</ng-template>
